import { DocumentTemplateScreenProps } from '../../types';
import DocumentTemplatesController from './document-templates.controller';

const DocumentTemplatesScreen = (props: DocumentTemplateScreenProps) => {
  return <DocumentTemplatesController {...props} />;
};

export default DocumentTemplatesScreen;
